import React, { Component } from 'react';
import CourseContext from 'src/pages/Course/CourseContext';

export interface IProps {}

export default class IFrameSlide extends Component<IProps> {
    static contextType = CourseContext;
    context!: React.ContextType<typeof CourseContext>;

    render() {
        return (
            <div>
                <b>Card not supported - IFrame</b>
            </div>
        );
    }
}
